<template>
  <div class="ac-snooze ac-card-content">
    <div class="ac-header-container">
      <div class="grid-column ai-c jc-s gap-10">
        <button
          type="button"
          class="ac-close-button"
          @click="toggleActionModal(false)"
        >
          <img
            src="@shared/assets/img/general/x-black.png"
            alt="x"
            class="ac-close"
          >
        </button>
        <div class="sac__font-18 semi-bold">
          Dismiss Alert
        </div>
      </div>
    </div>
    <div class="ac-body-container">
      <div class="ac-input-container">
        <div class="ac-input-header">
          Do you want to temporarily disable the alerts for systems?
        </div>
        <SACButtonSelect
          :value="isChronic"
          :options="[
            {
              label: 'Yes',
              value: true,
              show: true,
            },
            {
              label: 'No',
              value: false,
              show: true,
            },
          ]"
          :onSelect="(value) => setChronicSystem(value)"
        />
      </div>
      <div
        v-if="isChronic"
        class="ac-input-container"
      >
        <div class="ac-input-header">
          Dismiss for
        </div>
        <SACButtonSelect
          :value="dismissFor"
          :options="[
            {
              label: 'Custom',
              value: 0,
              show: true,
            },
            {
              label: '30 Days',
              value: 30,
              show: true,
            },
          ]"
          :onSelect="(value) => change('dismissFor', value)"
        />
        <input
          v-if="dismissFor === 0"
          class="ac-input-number"
          type="number"
          min="1"
          :value="customDismissFor"
          @change="handleCustomDays($event.target.value)"
        >
        <div v-if="error" class="sac__font-14 med tomato margin-top-8">
          {{ error }}
        </div>
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        class="sac__button bg-transparent"
        @click="toggleActionModal(false)"
      >
        Cancel
      </button>
      <button
        class="sac__button bg-primary margin-left-16"
        :disabled="loading"
        @click="handleDismiss"
      >
        <img
          v-if="loading"
          class="ac-processing"
          src="@shared/assets/img/general/loading-white.svg"
          alt="processing"
        >
        <span v-else>Save</span>
      </button>
    </div>
  </div>
</template>

<script>
import SACButtonSelect from '@shared/components/sac/SACButtonSelect.vue';
import serviceMixin from '@shared/mixins/serviceMixin';

export default {
  name: 'SetChronicAlert',
  components: {
    SACButtonSelect,
  },
  mixins: [serviceMixin],
  data() {
    return {
      isChronic: false,
      dismissFor: null,
      customDismissFor: 0,
      loading: false,
      error: null,
    };
  },
  methods: {
    change(f, v) {
      this[f] = v;
    },
    isValid() {
      if (this.isChronic) {
        if (!(this.dismissFor || this.customDismissFor)) {
          this.error = 'Please select or enter days.';
        } else {
          this.error = null;
        }
      }
      return !this.error;
    },
    async handleDismiss() {
      if (this.isChronic && this.isValid()) {
        const dismissDays = this.dismissFor || this.customDismissFor;
        this.$store.dispatch('setChronicAlertsForService', dismissDays);
      }
      this.toggleActionModal(false);
    },
    setChronicSystem(value) {
      this.isChronic = value;
    },
    handleCustomDays(value) {
      const number = Number(value);
      this.change('customDismissFor', number);
    },
  },
};
</script>
